<template>
  <div class="vuetify-isolated" style="max-width: 100%;">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'VuetifyWrapper',
  data() {
    return {
      cssLoaded: false
    }
  },
  beforeMount() {
    this.loadVuetifyCSS();
  },
  methods: {
    loadVuetifyCSS() {
      // Verifica se o CSS já foi carregado
      if (document.querySelector('#vuetify-isolated-css') || this.cssLoaded) {
        return;
      }
      
      // Cria link para carregar o CSS isolado
      const link = document.createElement('link');
      link.id = 'vuetify-isolated-css';
      link.rel = 'stylesheet';
      link.href = window.assetUrl + '/css/vuetify-isolated.css';
      link.onload = () => {
        this.cssLoaded = true;
      };
      
      document.head.appendChild(link);
    }
  },
  beforeDestroy() {
    // Remove o CSS quando todos os componentes Vuetify são destruídos
    const vuetifyComponents = document.querySelectorAll('.vuetify-isolated');
    if (vuetifyComponents.length <= 1) {
      const link = document.querySelector('#vuetify-isolated-css');
      if (link) {
        document.head.removeChild(link);
      }
    }
  }
}
</script>

<style scoped>
.vuetify-isolated {
  position: relative;
  font-family: 'Roboto', sans-serif;
}
</style>
